const _prefix = '@data/';

export default {
  GET_DISCLOSURE_DATA_REQUEST: _prefix + 'GET_DISCLOSURE_DATA_REQUEST',
  GET_DISCLOSURE_DATA_SUCCESS: _prefix + 'GET_DISCLOSURE_DATA_SUCCESS',
  GET_DISCLOSURE_DATA_ERROR: _prefix + 'GET_DISCLOSURE_DATA_ERROR',

  GET_PATIENT_DATA_REQUEST: _prefix + 'GET_PATIENT_DATA_REQUEST',
  GET_PATIENT_DATA_SUCCESS: _prefix + 'GET_PATIENT_DATA_SUCCESS',
  GET_PATIENT_DATA_ERROR: _prefix + 'GET_PATIENT_DATA_ERROR',

  UPDATE_DISCLOSURE_QUERIES: _prefix + 'UPDATE_DISCLOSURE_QUERIES',
  UPDATE_PATIENT_QUERIES: _prefix + 'UPDATE_PATIENT_QUERIES',

  GET_DATA_RECORD_DETAIL_REQUEST: _prefix + 'GET_DATA_RECORD_DETAIL_REQUEST',
  GET_DATA_RECORD_DETAIL_SUCCESS: _prefix + 'GET_DATA_RECORD_DETAIL_SUCCESS',
  GET_DATA_RECORD_DETAIL_ERROR: _prefix + 'GET_DATA_RECORD_DETAIL_ERROR',

  GET_YEARS_REQUEST: _prefix + 'GET_YEARS_REQUEST',
  GET_YEARS_SUCCESS: _prefix + 'GET_YEARS_SUCCESS',
  GET_YEARS_ERROR: _prefix + 'GET_YEARS_ERROR',

  GET_ROOT_SECTIONS_REQUEST: _prefix + 'GET_ROOT_SECTIONS_REQUEST',
  GET_ROOT_SECTIONS_SUCCESS: _prefix + 'GET_ROOT_SECTIONS_SUCCESS',
  GET_ROOT_SECTIONS_ERROR: _prefix + 'GET_ROOT_SECTIONS_ERROR',

  EXPORT_DATA_REQUEST: _prefix + 'EXPORT_DATA_REQUEST',

  DOWNLOAD_DATA_REQUEST: _prefix + 'DOWNLOAD_DATA_REQUEST',

  DELETE_DATA_RECORD_REQUEST: _prefix + 'DELETE_DATA_RECORD_DETAIL_REQUEST',
  UPDATE_DATA_RECORD_REQUEST: _prefix + 'UPDATE_DATA_RECORD_REQUEST',
  CHECK_UPDATE_DATA_RECORD_PROGRESS_REQUEST: _prefix + 'CHECK_UPDATE_DATA_RECORD_PROGRESS_REQUEST',
  CHECK_UPDATE_DATA_RECORD_PROGRESS_SUCCESS: _prefix + 'CHECK_UPDATE_DATA_RECORD_PROGRESS_SUCCESS',
  UPDATE_DATA_RECORD_PROGRESS: _prefix + 'UPDATE_DATA_RECORD_PROGRESS',

  UPDATE_DATA_RECORD_TO_PREVIEW: _prefix + 'UPDATE_DATA_RECORD_TO_PREVIEW',

  UPDATE_LOADING: _prefix + 'UPDATE_LOADING'
};
